var path = 'app/scripts/modules/core/src/pipeline/details/defaultExecutionDetails.html';
var html = "<div class=\"step-section-details\">\n  <div class=\"row\">\n    <execution-step-details item=\"stage\"></execution-step-details>\n  </div>\n</div>\n\n<stage-failure-message stage=\"stage\" message=\"stage.failureMessage\"></stage-failure-message>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/details/defaultExecutionDetails.html
// module id = 904
// module chunks = 0